import * as React from 'react';
import { Theme, StyleRules } from '@material-ui/core/styles';
import withStyles, { ClassNameMap } from '@material-ui/core/styles/withStyles';
import {
  Grid,
  FormControl,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  TextField,
} from '@material-ui/core';
import classNames from 'classnames';
import { ApplyContent } from '../modules/apply';

interface Props {
  classes: ClassNameMap;
  index: number;
  content: ApplyContent;
  oldCategories: { [key: string]: string };
  onChangeCategory: (index: number, category: number, content: ApplyContent) => void;
}

const style = (theme: Theme): StyleRules => ({
  root: {
    flexGrow: 1,
  },
  textFiled: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  paper: {
    padding: theme.spacing.unit * 2,
  },
  formControl: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: theme.spacing.unit,
  },
});

class ApplyTarget extends React.Component<Props> {
  handleChangeCategory = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { onChangeCategory, content, index } = this.props;
    const { value } = event.target;
    onChangeCategory(index, +value, content);
  }

  render() {
    const { classes, index, content, oldCategories } = this.props;
    return (
      <div className={classes.root} >
        <Paper
          className={
            classNames(classes.paper)
          }
        >
          <Grid container direction="column" key={index} spacing={16}>
            <Grid item>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="set-category">● 設定カテゴリ: </InputLabel>
                <Select
                  value={content.newTagId}
                  inputProps={{
                    name: 'category',
                    id: 'set-category',
                  }}
                  onChange={this.handleChangeCategory}
                >
                  {Object.keys(oldCategories).map((k, i) => (
                    <MenuItem key={i} value={k}>{oldCategories[k]}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl className={classes.formControl}>
                <TextField disabled label="● ファイル名" value={content.fileName} />
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl className={classes.formControl}>
                <TextField disabled multiline label="● 文書" value={content.text} />
              </FormControl>
            </Grid>
          </Grid>
        </Paper>
      </div>
    );
  }
}
export default withStyles(style)(ApplyTarget);



// WEBPACK FOOTER //
// ./src/components/ApplyTarget.tsx